import { Close } from '@mui/icons-material';
import { IconButton,MenuItem,Select,SelectChangeEvent } from '@mui/material';
import { useEffect,useState } from 'react';
import { ReactNode } from 'react';
import { StoneXLabeledItem } from '..';
import { useMemo } from 'react';

interface PropsType<TItem> {
  options: TItem[];
  getId: (q: TItem) => string | number;
  getOptionLabel: (q: TItem) => string | number;
  onChange?: (item: TItem | null) => void;
  label?: ReactNode;
  value?: TItem | null;
  width?: 'small' | string | number;
  fullWidth?: boolean;
  placeholder?: string;
  isControlled?: boolean;
  disabled?: boolean;
  clearable?: boolean;
  variant?:  "outlined" | "filled" | "standard";
  helperText?: string;
  error?: string;
  menuOptionDisabled?: (condition: TItem) => boolean;
}

export function StoneXSelect<TItem>(props: PropsType<TItem>) {
  
  const [selectedValue, setSelectedValue] = useState<TItem | null>(props.value ?? null);

  function onItemSelected(event: SelectChangeEvent) {
    const value = props.options.find(q => props.getId(q) == event?.target?.value);
    props.onChange && props.onChange(value ?? null);
    
    if (!props.isControlled) {
      setSelectedValue(value ?? null);
    }
  }

  function clearItemSelected() {
    props.onChange && props.onChange(null);

    if (!props.isControlled) {
      setSelectedValue(null);
    }
  }

  useEffect(() => {
    if (props.value) {
      const value = props.options.find(q => props.getId(q) === props.getId(props.value!));
      setSelectedValue(value ?? null);
    }

  }, [props.value])

  const width = useMemo(() => {

    if (props.width === 'small') {
      return '180px';
    }

    if (props.fullWidth) {
      return '100%';
    }

    return props.width ?? '250px';

  }, [props.width, props.fullWidth]);

  return (
    <StoneXLabeledItem label={props.label} width={width} fullWidth={props.fullWidth}>
      <Select
        variant={props.variant}
        sx={{ width: width }}
        value={(selectedValue && props.getId(selectedValue))?.toString() ?? ''}
        onChange={onItemSelected}
        disabled={props.disabled}
        placeholder={props.placeholder}
        error={!!props.error}
        endAdornment={
          selectedValue && props.clearable ? (
            <IconButton onClick={clearItemSelected}>
              <Close />
            </IconButton>
          ) : (
            false
          )
        }        
      >
        {props.options.map((q) => (
          <MenuItem key={props.getId(q)} value={props.getId(q)} disabled={(props.menuOptionDisabled && props.menuOptionDisabled(q)) ?? undefined}>
            {props.getOptionLabel(q)}
          </MenuItem>
        ))}
        </Select>
        {(props.error || props.helperText) && (
          <div style={{ color: props.error ? '#d32f2f' : '#000000', opacity: props.error ? undefined : '.6', fontSize: '0.75rem', marginTop: '3px' }}>
            {props.error ?? props.helperText}
          </div>
        )}
    </StoneXLabeledItem>
  );
}